import type { LucideIcon } from 'lucide-react'
import {
  Award,
  Bookmark,
  Circle,
  ClipboardList,
  Gamepad2,
  LayoutDashboard,
  Layers,
  Package,
  Settings,
  Shapes,
  ShoppingCart,
  Store,
  Tag,
  Ticket,
  Users,
} from 'lucide-react'

/**
 * Font Awesome sınıf dizilerini (CodeXpin / seeder) Lucide bileşenine çevirir.
 */
export function menuFaToLucide(icon: string | null | undefined): LucideIcon {
  if (!icon?.trim()) {
    return Circle
  }
  const s = icon.toLowerCase()

  if (s.includes('tachometer')) return LayoutDashboard
  if (s.includes('basket') || s.includes('cart') || s.includes('shopping')) return ShoppingCart
  if (s.includes('bookmark')) return Bookmark
  if (s.includes('tag') && !s.includes('price')) return Tag
  if (s.includes('boxes') || s.includes('box')) return Package
  if (s.includes('layer')) return Layers
  if (s.includes('award') || s.includes('crown')) return Award
  if (s.includes('shape') || s.includes('pentagon')) return Shapes
  if (s.includes('gamepad') || s.includes('platform')) return Gamepad2
  if (s.includes('users') || s.includes('user')) return Users
  if (s.includes('shop') || s.includes('store')) return Store
  if (s.includes('slider')) return Settings
  if (s.includes('clipboard')) return ClipboardList
  if (s.includes('ticket')) return Ticket
  if (s.includes('cog') || s.includes('gear') || s.includes('display')) return Settings

  return Circle
}
